<template>
  <v-row>
	  <v-col cols="12">
	    <logs-aplicacao-data-table
        :items="items"
        :loading="loading"
        @recarregar="getLogs($event)"
      />
	  </v-col>
  </v-row>
</template>

<script>
import logsAplicacao from '@/services/LogsAplicacao';

export default {
  components: {
    LogsAplicacaoDataTable: () => import("@/components/logsAplicacao/LogsAplicacaoDataTable.vue")
  },

  created() {
    this.getLogs();
  },

  data: () => ({
    items: [],
    loading: false
  }),

  methods: {
    getLogs(all = false) {
      this.loading = true;
      this.items = [];
      
      logsAplicacao.getLogs(all)
      .then(resp => {
        this.items = resp.data.logs;
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao recuperar Logs da aplicação.', '',{position:'topRight'});
      })
      .finally(()=> this.loading = false);
    }
  }
}
</script>